import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSonarObjectProfiles } from '@api';
import { updateSonarObjectReferences } from '../_idMap/actions';

export const getCoreSonarObjectsProfilesAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		cache: true,
		successCombinationActionCreators: [
			(request, data) => updateSonarObjectReferences([ {
				salesforce: {
					profiles: data
				},
				sonarObjectId: request.sonarObjectId
			} ])
		]
	},
	name: 'CoreSonarObjectsProfiles',
	receive: true,
	request: true,
	requestHandler: getSonarObjectProfiles
});
